import { Injectable } from '@angular/core';
import { GET_TRANSLATIONS } from "../store/entities/system-configurations/temp-fcrs/translation/translation.graphql";
import { upsertTranslations } from "../store/entities/system-configurations/temp-fcrs/translation/translation.actions";
import { Translation } from "../store/entities/system-configurations/temp-fcrs/translation/translation.model";
import { GraphqlService } from "./graphql.service";
import { BaseResponse } from "../common/interfaces/global-interfaces";
import { Store } from "@ngrx/store";
import { AppState } from "../store";
import { NotificationService } from "./notification.service";

@Injectable({
  providedIn: 'root'
})
export class InitTranslationService {

  constructor(
    private apollo: GraphqlService,
    private store: Store<AppState>,
    private notificationService: NotificationService,
  ) {
  }

  async initTranslations() {
    // try {
    //   const response = await this.apollo.query({
    //     query: GET_TRANSLATIONS
    //   });
    //   const result: BaseResponse<Translation[]> = Object.values(Object.values(response)[0])[0];
    //
    //   if (result?.response?.status) {
    //     this.store.dispatch(upsertTranslations({translations: result?.data || []}));
    //   } else {
    //     throw Error(result?.response?.message);
    //   }
    // } catch (e) {
    //   this.notificationService.errorMessage(e.message);
    // }
  }
}
